import { render, staticRenderFns } from "./itemsPagination.vue?vue&type=template&id=2f3d5d3c"
import script from "./itemsPagination.vue?vue&type=script&lang=js"
export * from "./itemsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports